const findGatewayOrDestinationMatch = (data, _match) => {
	const gateway = data.find(
		({ code }) => code === _match || code.includes(_match)
	);

	return gateway ? { label: gateway.name, value: gateway.code } : {};
};

export { findGatewayOrDestinationMatch };
export default findGatewayOrDestinationMatch;
